import React from 'react'
import Activity from 'src/app/Activity/Activity'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { activityRouteProps } from 'src/navigation/routeProps'

const ActivityAppRoute: AppRoute = {
  id: AppLocation.Activity,
  routeProps: activityRouteProps,
  component: <Activity />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ActivityAppRoute
